import { PostgrestError } from "@supabase/supabase-js";

export class DatabaseError extends Error {
  constructor(
    message: string,
    public originalError: PostgrestError | Error | unknown,
    public operation: string,
  ) {
    super(message);
    this.name = "DatabaseError";
  }
}

export async function withErrorHandling<T>(
  operation: string,
  fn: () => Promise<T>,
): Promise<T> {
  try {
    return await fn();
  } catch (error) {
    if (error instanceof PostgrestError) {
      throw new DatabaseError(
        `Database operation failed: ${error.message}`,
        error,
        operation,
      );
    } else if (error instanceof Error) {
      throw new DatabaseError(
        `Unexpected error during database operation: ${error.message}`,
        error,
        operation,
      );
    } else {
      throw new DatabaseError(
        "Unknown error during database operation",
        error,
        operation,
      );
    }
  }
}
